import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/es5/util/colors';

const customColors = {
	combobox: '#3d4e60',
	contentprovider: '#4A4C9E',
	serviceprovider: '#2483D1',
	white: '#fafafa',
	create: '#222F3A',
	edit: '#A1961F',
	delete: '#9E4B47',
	assign: '#76B38D',
	anchor: '#0c64ff',
	'menu-items': '#c8c7c9',
	'active-item': '#3c4d5f'
};

Vue.use(Vuetify, {
	theme: {
		primary: colors.grey.darken4, // $black
		secondary: '#979797', // $brown-gray
		tertiary: '#222e3c',
		accent: '#0c64ff', // $bright-blue
		error: '#FF5252',
		info: '#3E576C',
		success: '#4CAF50',
		warning: '#FFC107',
		...customColors
	},
	iconfont: 'md'
});
